<div [ngClass]="{ 'layout-topbar': true, 'test': isTestEnvironment }">
  <a href="#" id="topbar-menu-button" (click)="menuButtonClick($event)">
    <i class="pi pi-angle-left arrow"></i>
    <i class="pi pi-angle-up mobile"></i>
  </a>

  <span *ngIf="isPropak" class="logo-container">
    <img src="/logo-propak-white.svg" alt="" />
    <span class="logo-text">
      PROPAK Vision{{ isTestEnvironment ? ' Test' : '' }}
    </span>
  </span>

  <span *ngIf="!isPropak" class="logo-container">
    <img src="/logo-white.svg" alt="PLA" />
    <span class="logo-text">
      Vision{{ isTestEnvironment ? ' Test' : '' }}
    </span>
  </span>

  <div class="topbar-items right">
    <div>
      <span *ngIf="!isTestEnvironment" [title]="username">
        {{ displayName }}
      </span>
      <span>
        <button *ngIf="isTestEnvironment" pButton class="p-button-secondary" (click)="openDialog()"
          [label]="displayName" [title]="username">
        </button>
      </span>
    </div>

    <button pButton (click)="logout()" label="Sign Out" icon="pi pi-sign-out" iconPos="right"
      class="p-button-nonbutton light"></button>
  </div>
</div>

<p-dialog header="Impersonate User" [modal]="true" [(visible)]="showImpersonateDialog">
  <p>Impersonation is temporarily unavailable. Contact Sam if you have questions.</p>
  <div class="form-group">
    <label class="required" for="description">User Account</label>
    <input pInputText type="text" id="description" [(ngModel)]="impersonationUsername" disabled />
  </div>
  <button pButton type="button" class="p-button-info" label="Stop Impersonation" (click)="cancelImpersonation()">
  </button>
  <button pButton type="button" class="p-button-success" label="Start Impersonation" (click)="setImpersonation()">
  </button>

</p-dialog>
